import { message as MessageAnt } from 'antd';

const message = MessageAnt;

export default message;
